export enum EventType {
  Automatic = 'auto',
  Manual = 'manual',
}
